module.exports = __webpack_public_path__ + "img/duty_charge.920b07b0.png";